import { useState } from "react";

/**
 * Аватар участника.
 *
 * Фото приходит из Telegram и кэшируется бэкендом, но его может не быть
 * никогда: пользователь мог закрыть фото приватностью, объектное хранилище
 * может быть выключено, а ссылка — протухнуть между входом и загрузкой. Все
 * четыре случая приводят сюда одинаково: `src` пустой или картинка не
 * загрузилась. Поэтому фолбэк не запасной путь, а равноправный.
 *
 * Инициал приходит готовым с сервера — на клиенте он не режется: правило «фронт
 * ничего не вычисляет» касается и первой буквы имени, которое может начинаться
 * с суррогатной пары.
 */
interface AvatarProps {
  src: string | null | undefined;
  initial: string;
  /** Диаметр в пикселях — берётся из макета. */
  size: number;
  className?: string;
}

export function Avatar({ src, initial, size, className }: AvatarProps) {
  const [broken, setBroken] = useState(false);

  const shared = ["shrink-0 rounded-full object-cover", className ?? ""].join(" ");
  const box = { width: size, height: size };

  if (src && !broken) {
    return (
      <img
        src={src}
        alt=""
        aria-hidden="true"
        loading="lazy"
        onError={() => {
          setBroken(true);
        }}
        className={shared}
        style={box}
      />
    );
  }

  return (
    <span
      aria-hidden="true"
      className={["flex items-center justify-center font-bold text-text-inverse", shared].join(" ")}
      style={{ ...box, backgroundImage: "var(--gradient-brand)", fontSize: Math.round(size * 0.36) }}
    >
      {initial}
    </span>
  );
}
